<template>
    <component v-if="selectedStickerComponent" :is="selectedStickerComponent" :anonymous-type="stickerSubtype" />
</template>

<script lang="ts" setup>
import { defineAsyncComponent, markRaw, computed } from "vue";
import { useLoyaltySticker } from "./use-loyalty-sticker";
import { storeToRefs } from "pinia";

const { stickerType, stickerSubtype } = storeToRefs(useLoyaltySticker());

const selectedStickerComponent = computed(() => {
    switch (stickerType.value) {
        case "Anonymous":
            return markRaw(
                defineAsyncComponent(
                    () => import("@/loyalty/components/loyalty-sticker/stickers/anonymous-sticker.vue")
                )
            );
        case "Bonusomat":
            return markRaw(
                defineAsyncComponent(() => import("@/casino/bonusomat/components/sticker/bonusomat-sticker.vue"))
            );
        case "GoldenWheel":
            return markRaw(defineAsyncComponent(() => import("@/golden-wheel/components/gw-sticker.vue")));

        case "FurrySpin":
            return markRaw(defineAsyncComponent(() => import("@/furry-spin/components/fs-sticker.vue")));

        default:
            return null;
    }
});
</script>
